import { SideListOptionType } from '@fi-shared/types';
import { AppTextService } from '@fi-shared/app-text';
import { ISideListOptionsItem } from '@fi-shared/fi-items-list/fi-items-list';

export function getSideListOptionsBottomFn(appTextService: AppTextService): ISideListOptionsItem[] {
    return [
        { value: SideListOptionType.LastDay, text: appTextService.get('common.last_day') },
        { value: SideListOptionType.LastWeek, text: appTextService.get('common.last_week') },
        { value: SideListOptionType.LastMonth, text: appTextService.get('common.last_month') },
        { value: SideListOptionType.LastQuarter, text: appTextService.get('common.last_quarter') },
    ];
}
